<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="售后状态：">
        <el-select v-model="query.state" placeholder="请选择售后状态" clearable size="small" >
          <el-option label="待寄回商品" value="2"></el-option>
          <el-option label="待收货" value="3"></el-option>
          <el-option label="待处理售后" value="31"></el-option>
          <el-option label="等待用户确认结果" value="4"></el-option>
          <el-option label="已完成" value="5"></el-option>
          <el-option label="终止售后" value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间筛选：">
        <el-select v-model="query.searchTimeType" placeholder="请选择" clearable size="small">
          <el-option label="申请时间" :value="1"></el-option>
          <el-option label="同意申请时间" :value="2"></el-option>
          <el-option label="寄回商品时间" :value="3"></el-option>
          <el-option label="售后处理时间" :value="4"></el-option>
          <el-option label="完成时间" :value="5"></el-option>
          <el-option label="驳回时间" :value="6"></el-option>
        </el-select>
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="客户所属省市区：">
        <!--
          REQ-2026-842631 导出也要有省市区筛选。
          ⚠️ 这个表单**被两个入口共用**（export/list/index.vue:36 按 code=ExportOrderAfterExport 渲染）：
             ① 订单管理-售后订单-导出   ② 财务-对账-「售后对账」按钮
             所以这个筛选项财务那边也会看到。不选时行为与改动前完全一致，
             但改这里要想到财务那张对账表——多一行少一行都是钱。
        -->
        <el-cascader v-model="addrPaths" :props="cascaderProps" collapse-tags :options="addressList"
          :show-all-levels="false" clearable placeholder="请选择省市区" size="small"></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import sysAddrApi from '@/api/sys/sysAddr'
// 省市区路径的级间分隔符，与后端 CustomerAddrPathQO.PATH_SEPARATOR 一致；不能用逗号（BUG-2026-284617，见 toAddrPaths）
const ADDR_PATH_SEPARATOR = '-'

export default {
  props: ['orderType'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        state: '',
        searchTimeType: ''
      },
      categorizeIdArr: [],
      categorizeOptions: [],  //商品分类
      // REQ-2026-842631 客户所属省市区（多选）
      addrPaths: [],
      addressList: [],
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true,
        multiple: true
      },
    }
  },
  created() {
    this.getAddressList()
  },
  methods: {
    /**
     * 把多选级联的值编码成**路径字符串数组**：`['51', '53-5301', '51-5101-510107']`。
     *
     * ⚠️ 级间分隔符是 `-` 不是逗号（BUG-2026-284617）：只选一个市时请求里 addrPaths 只有一个值，
     *    Spring 把单值含逗号的 `53,5301` 按逗号拆成 ['53','5301'] 两条整省路径，市级丢了、退化成整省
     *    （昆明市期望 97 实得 443）；选两个以上时不拆，所以时好时坏。后端 CustomerAddrPathQO.PATH_SEPARATOR 同字符。
     *
     * ⚠️ 与 order/afterorder/list.vue 的 toAddrPaths **是同一套口径**，改一处要改两处。
     *
     * ⚠️ **不能返回对象数组**。列表接口是 GET，全局序列化器是
     *    `qs.stringify(params, {arrayFormat:'repeat'})`，repeat 格式不带下标，
     *    对象数组会被拍成
     *      addrPaths[provinceCode]=51&addrPaths[provinceCode]=53&addrPaths[cityCode]=5301
     *    —— "哪个市属于哪个省"在 URL 里就丢了，等于回到"三个扁平袋子"那个 bug。
     *    编成字符串后是 addrPaths=51&addrPaths=53-5301，GET/POST 都干净。
     *
     * ⚠️ **也不能只在这一个请求上换序列化器**：那会让这个接口的参数风格和全站不一致，
     *    下一个人改这里很容易踩回去。更不能改 request.js 的全局 arrayFormat（影响所有列表页）。
     *
     * ⚠️ `checkStrictly: true` 下路径长度 1~3 不固定，按长度逐级取；空路径跳过。
     */
    toAddrPaths(paths) {
      if (!Array.isArray(paths) || paths.length === 0) return undefined
      const result = []
      paths.forEach(path => {
        if (!Array.isArray(path) || path.length === 0) return
        const codes = []
        for (let i = 0; i < path.length && i < 3; i++) {
          if (path[i] == null || path[i] === '') break
          codes.push(String(path[i]))
        }
        if (codes.length) result.push(codes.join(ADDR_PATH_SEPARATOR))
      })
      return result.length ? result : undefined
    },
    /** 地区树：children 为空数组时置 undefined，否则级联器会画出一个空的下一级 */
    formatCascaderData(data) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].child || data[i].child.length < 1) {
          data[i].child = undefined
        } else {
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({ data }) => {
        this.addressList = this.formatCascaderData(data)
      })
    },
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      // REQ-2026-842631：不选时 addrPaths 是 undefined，请求体里不会出现这个键，
      // 后端 <if test="addrPaths != null and addrPaths.size() > 0"> 不成立 —— 与改动前逐行一致。
      // 这条对**财务对账入口**尤其要紧：那张表是拿去对账的，多一行少一行都是钱。
      this.query.addrPaths = this.toAddrPaths(this.addrPaths)
      return this.$common.confirm('是否确认导出')
        .then(() => goodsOrderApi.exportOrderAfterExcel(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },

  }

}
</script>

<style>
</style>